import React from 'react';

export interface AnalysisWorkspaceContextValue {
  openCode: (code: string, language: string, label: string) => void;
}

export const AnalysisWorkspaceContext = React.createContext<AnalysisWorkspaceContextValue | null>(null);
